import { useState } from "react";
import { useTranslation } from "react-i18next";

const AboutSection = () => {
  const { t } = useTranslation();
  const [activeImage, setActiveImage] = useState(0);

  const images = [
    "/images/about-img.png",
    "images/hero.webp",
    "/images/about-img2.jpeg",
    "/images/about-img3.jpg",
  ];

  return (
    <section className="about-section">
      <div className="container">
        <div className="row align-items-center">
          {/* <div className="col-lg-6">
            <div className="image-gallery">
              <div className="main-image">
                <img
                  src={images[activeImage]}
                  alt={t("about-image-alt")}
                  className="img-fluid"
                />
              </div>
              <div className="thumbnail-container">
                {images.map((img, index) => (
                  <div
                    key={index}
                    className={`thumbnail ${
                      index === activeImage ? "active" : ""
                    }`}
                    onClick={() => setActiveImage(index)}
                  >
                    <img
                      src={img}
                      alt={t("thumbnail-alt", { number: index + 1 })}
                      style={{maxWidth:'120px'}}
                    />
                  </div>
                ))}
              </div>
            </div>
          </div> */}
          <div
            className="col-lg-12"
            
          >
            <div className="content-wrapper">
              <div className="section-header">
                <h1 className="fw-bold text-secondary">{t("about-us")}</h1>
                <div className="section-title"></div>
              </div>
              <div className="text-content">
                <p>{t("about-description-1")}</p>
                <p>{t("about-description-2")}</p>
              </div>
              {/* <div className="stats-container">
                <div className="stat-item">
                  <span className="stat-number">10+</span>
                  <span className="stat-label">{t("agents-count")}</span>
                </div>
                <div className="stat-item">
                  <span className="stat-number">30+</span>
                  <span className="stat-label">{t("marketers-count")}</span>
                </div>
                <div className="stat-item">
                  <span className="stat-number">4+</span>
                  <span className="stat-label">{t("brands-count")}</span>
                </div>
              </div> */}
              <div className="cta-buttons" style={{ justifyItems: "center", justifyContent: "center" }}>
                <a href="#products">
                  <button className="btn btn-primary">
                    {t("explore-products")}
                  </button>
                </a>

                <a href="#contact">
                  <button className="btn btn-outline">{t("contact-us")}</button>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
